import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message", "options", "defaultValue", "messageComponent"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { interpolate } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
function ValidI18nMessage(props) {
  const {
      message,
      options,
      defaultValue = '',
      messageComponent: MessageComponent = FormattedMessage
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (!isValidI18nKey(message)) {
    return /*#__PURE__*/_jsx(SanitizedText, {
      body: interpolate(defaultValue, options),
      WrapperComponent: "span"
    });
  }
  return /*#__PURE__*/_jsx(MessageComponent, Object.assign({
    message: message,
    options: options
  }, rest));
}
export default ValidI18nMessage;